/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TaskDetailTextOutcome = typeof TaskDetailTextOutcome[keyof typeof TaskDetailTextOutcome] | null;


export const TaskDetailTextOutcome = {
  sent: 'sent',
  no_reply: 'no_reply',
  replied: 'replied',
  bounced: 'bounced',
  other: 'other',
} as const;
